import { FILTER_OUT } from 'ACTIONS';

export const filter = (param = '', req) => ({
    type: FILTER_OUT,
    payload: param,
    req
});
